
export const CONNECT_TYPE = {
  METAMASK: 'Metamask',
  WEB3_MODAL: 'Web3Modal'
  };

export const LOCAL_STORAGE_KEY = {
    WEB3_MODAL_ACCOUNT_INFO : 'WEB3_MODAL_ACCOUNT_INFO'
}